import { ROLES } from "./rolePermissions";

/**
 * Fallback username → role map when auths.role is NULL in the database.
 * Source of truth: auths.role column returned from GET /api/auths/me.
 * Add entries here only until roles are assigned in the DB.
 */
export const USERNAME_ROLE_MAP = {
  "admin-1": ROLES.ADMIN,
  marketing: ROLES.MARKETING,
  claim: ROLES.CLAIM,
  ds: ROLES.DS,
  "call-center": ROLES.CALL_CENTER,
  ps: ROLES.PS,
  uw: ROLES.UW,
  pc: ROLES.PC,
};
